import TrainingEnrollmentModal from './TrainingEnrollmentModal.vue';

export default TrainingEnrollmentModal;
